import { c as _c } from "react/compiler-runtime";
import { SEO } from "@/components/SEO";
import { PageTransitionProvider } from "@/context/PageTransitionContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { useConsoleArt } from "@/hooks/useConsoleArt";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";
import { useServiceWorker } from "@/hooks/useServiceWorker";
import { Iridescence } from "@/layout/Iridescence";
import { RootLayout } from "@/layout/RootLayout";
import "@/styles/globals.css";
import { Analytics } from "@vercel/analytics/next";
import { SpeedInsights } from "@vercel/speed-insights/next";
import type { AppProps } from "next/app";
export default function App(t0) {
  const $ = _c(8);
  const {
    Component,
    pageProps
  } = t0;
  useConsoleArt();
  useInstallPrompt();
  useServiceWorker();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SEO />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Component || $[2] !== pageProps) {
    t2 = <Iridescence speed={0.1} mouseReact={false}><PageTransitionProvider><RootLayout><Component {...pageProps} /></RootLayout></PageTransitionProvider></Iridescence>;
    $[1] = Component;
    $[2] = pageProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Analytics />;
    t4 = <SpeedInsights />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2) {
    t5 = <ThemeProvider>{t1}{t2}{t3}{t4}</ThemeProvider>;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}